import {
  LocationAlarmUpdate,
  ModifyAlarmUpdateEntry,
} from '@hakimo-ui/hakimo/types';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useEffect, useState } from 'react';
import { derivedUpdateType } from '../../sop-workflow/util';
import { displayTime, formatDispatchUpdateLabel } from '../alarm-updates/util';

dayjs.extend(utc);
dayjs.extend(timezone);

export const DISPATCH_FMT = 'DD-MM-YYYY HH:mm:ss';

export interface TimelineEntryViewProps {
  ev: LocationAlarmUpdate;
  pending: Partial<ModifyAlarmUpdateEntry>;
  pendingFiles?: File[];
  timezone?: string;
  editDisabled: boolean;
  onEdit: () => void;
}

export function useTimelineEntryView(
  ev: LocationAlarmUpdate,
  p: Partial<ModifyAlarmUpdateEntry>,
  pendingFiles: File[],
  tz?: string
) {
  const [viewBlobUrls, setViewBlobUrls] = useState<string[]>([]);

  useEffect(() => {
    const newUrls = pendingFiles.map((f) => URL.createObjectURL(f));
    setViewBlobUrls(newUrls);
    return () => newUrls.forEach(URL.revokeObjectURL);
  }, [pendingFiles]);

  const effectiveType = derivedUpdateType(
    p.update_type ?? (ev.update_type as string)
  );
  const d = dayjs(displayTime(ev, p));
  const dispTime = (tz ? d.tz(tz) : d).format(DISPATCH_FMT);
  const badgeLabel =
    effectiveType === 'evidence'
      ? 'Evidence Added'
      : formatDispatchUpdateLabel(
          effectiveType,
          p.responder_type ?? ev.responder_type,
          p.dispatch_status ?? ev.dispatch_status
        );
  const effectiveComment = (
    p.comment ??
    ev.escalation_comment ??
    ev.comment ??
    ev.notes ??
    ''
  ).trim();
  const effectiveS3Urls = p.s3_urls ?? ev.s3_urls ?? [];
  const allSnapshotUrls = [...effectiveS3Urls, ...viewBlobUrls];

  return {
    effectiveType,
    dispTime,
    badgeLabel,
    effectiveComment,
    allSnapshotUrls,
    snapshotCount: allSnapshotUrls.length,
  };
}
